import { Funcionalidade } from '../../core/domain/funcionalidade/funcionalidade';
import { FuncionalidadeDto } from '../dto/funcionalidade.dto';
import { ModuloMapper } from './modulo.mapper';

export class FuncionalidadeMapper {
  static toDomain(funcionalidadeDto: FuncionalidadeDto): Funcionalidade {
    return {
      id: funcionalidadeDto.id,
      descricao: funcionalidadeDto.descricao,
      rota: funcionalidadeDto.rota,
      indPermissionado: funcionalidadeDto.indPermissionado,
      urlExterna: funcionalidadeDto.urlExterna,
      modulo: funcionalidadeDto.modulo
        ? ModuloMapper.toDomain(funcionalidadeDto.modulo)
        : undefined // Mapeando o módulo, se presente
    };
  }

  static toDTO(funcionalidade: Funcionalidade): FuncionalidadeDto {
    return {
      id: funcionalidade.id,
      descricao: funcionalidade.descricao,
      rota: funcionalidade.rota,
      indPermissionado: funcionalidade.indPermissionado,
      urlExterna: funcionalidade.urlExterna,
      modulo: funcionalidade.modulo
        ? ModuloMapper.toDTO(funcionalidade.modulo)
        : undefined // Mapeando o módulo, se presente
    };
  }
}
